/**
 * @generated SignedSource<<78e115611cf8c17d6b94c62d361583ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InterviewIntroSection_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hint",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerOralInterview",
  "abstractKey": null
};

node.hash = "6fc3f335e4927956165fb0c5cd0711b5";

module.exports = node;
